import {
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	CardHeading,
	CheckboxField,
	Loading,
	SubmitButton,
	isSuccess,
	useToasts,
} from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { Form, Formik } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useModuleSettings } from "../appSettings/useModuleSettings";
import { moduleSettingService } from "../shared/api/moduleSettingService";
import { ModuleSettingsFormValues } from "../shared/types/moduleSettings";

const VerticalCheckboxs = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacing(10)};
	padding-top: ${({ theme }) => theme.spacing(2)};
`;

export const AppSettingsPage: FC = () => {
	const { t } = useTranslation();
	const queryClient = useQueryClient();
	const { moduleSettings, isLoading } = useModuleSettings();
	const { showToast } = useToasts();

	const handleSubmit = async (values: ModuleSettingsFormValues) => {
		const response = await moduleSettingService.update(values);

		if (isSuccess(response)) {
			void queryClient.invalidateQueries({ queryKey: moduleSettingService.baseKey });
			showToast({
				type: "success",
				title: t("App settings"),
				body: t("App settings was successfully updated."),
			});
			return true;
		}

		return false;
	};

	if (isLoading || !moduleSettings) {
		return <Loading />;
	}

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("App settings")}</CardHeading>
			</CardHeader>
			<Formik initialValues={moduleSettings} onSubmit={handleSubmit}>
				<Form>
					<CardBody>
						<h4>{t("Show events")}</h4>
						<VerticalCheckboxs>
							<CheckboxField label={t("Public area")} name="showEventsPublic" />
							<CheckboxField label={t("Private area")} name="showEventsPrivate" />
						</VerticalCheckboxs>
						<h4>{t("Show invitations")}</h4>
						<VerticalCheckboxs>
							<CheckboxField label={t("Public area")} name="showInvitationsPublic" />
							<CheckboxField label={t("Private area")} name="showInvitationsPrivate" />
						</VerticalCheckboxs>
					</CardBody>
					<CardFooter>
						<SubmitButton>{t("Save")}</SubmitButton>
					</CardFooter>
				</Form>
			</Formik>
		</Card>
	);
};
